export * from "-!../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../node_modules/vue-style-loader/index.js!../node_modules/css-loader/index.js??ref--9-2!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/lib/index.js??ref--9-3!../node_modules/sass-loader/lib/loader.js??ref--9-4!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=style&index=2&id=dbf4d1f4&prod&lang=scss"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=style&index=2&id=dbf4d1f4&prod&lang=scss
// module id = HXee
// module chunks = 1